import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong, faCircleCheck, faPhoneVolume } from "@fortawesome/free-solid-svg-icons";
import "./FreeTrial.scss";

const perkKeys = ["free_30", "all_features", "support", "migration"];

// `scheduleCall`: opens the call-booking modal (also offered as the hero's secondary button,
// next to its "Essai gratuit" call to action).
const FreeTrial = ({ scheduleCall }) => {
  const { t, i18n } = useTranslation();
  return (
    <section className="syd-freetrial">
      <div className="container">
        <motion.div
          className="syd-freetrial__box"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="syd-freetrial__content">
            <h2 className="syd-freetrial__title">
              {t("landing.freetrial.title_pre")}
              <br />{t("landing.freetrial.title_post")}
            </h2>
            <p className="syd-freetrial__sub">
              {t("landing.freetrial.sub")}
            </p>
            <ul className="syd-freetrial__perks">
              {perkKeys.map((key, i) => (
                <li key={i}>
                  <FontAwesomeIcon icon={faCircleCheck} />
                  {t(`landing.freetrial.perk_${key}`)}
                </li>
              ))}
            </ul>
            <div className="syd-freetrial__actions">
              <a href={`/${i18n.language}/register`} className="syd-freetrial__btn">
                {t("landing.freetrial.cta")}
                <FontAwesomeIcon icon={faArrowRightLong} />
              </a>
              {scheduleCall && (
                <button type="button" className="syd-freetrial__btn-ghost" onClick={scheduleCall}>
                  <FontAwesomeIcon icon={faPhoneVolume} />
                  {t("landing.freetrial.demo_cta")}
                </button>
              )}
            </div>
          </div>

          <div className="syd-freetrial__visual">
            <div className="syd-freetrial__card">
              <div className="syd-freetrial__card-badge">{t("landing.freetrial.card_badge")}</div>
              <div className="syd-freetrial__price">
                <span className="syd-freetrial__price-amount">0 Dhs</span>
                <span className="syd-freetrial__price-period">{t("landing.freetrial.card_period")}</span>
              </div>
              <p className="syd-freetrial__card-note">
                {t("landing.freetrial.card_note")}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FreeTrial;
